import Vue from 'vue'
import {CancelToken} from 'axios'
import {http} from '@/axios'
import $router from '@/router'
import {EMPLOYEE, EMPLOYER} from '@/constants/usersTypes'
// import {STEP_EMPLOYMENT_TYPE} from '../../constants/interaction'
import visa from './visa'
import statement from './statement'
import chat from './chat'
import files from './files'

let cancel;

const genders = [{
  id: 1,
  name: 'Man'
}, {
  id: 2,
  name: 'Woman'
}]

const yesOrNo = [{
  id: true,
  name: 'Yes'
}, {
  id: false,
  name: 'No'
}]

const otherCountry = {
  id: 'other',
  name: 'Other'
}


function getInitState() {
  return {
    step: null,
    pending: false,
    waiting: false,
    title: null,
    waitingText: null,
    hint: null,
    showHintDefault: true,
    data: null,
    stepData: null,
    watchTimer: null,
    statuses: null,
    vacancy: null,
    resume: null,
    // chatMessages: [],

    //SETTINGS
    yesOrNo,
    genders,
    otherCountry,
    maritalStatuses: null,
    documents: null,
    relativeLevels: null,
    rejectReasons: null,
    clothingSizes: null,
  }
}

export default {
  namespaced: true,
  modules: {
    visa,
    chat,
    files,
    statement,
  },
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },

  },
  actions: {
    stopWatchNextStep({dispatch}) {
      if (cancel) {
        cancel()
        cancel = null
      }
      dispatch('unSubscribeOnUpdate')
    },
    subscriberOnUpdate({rootState, dispatch}) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unSubscribeOnUpdate')

      const channel = rootState.user.userPusher.channel
      channel.bind('update-interaction', ({update}) => {
        dispatch('loadInteraction', update.interaction_id)
      })
    },
    unSubscribeOnUpdate({rootState}) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('update-interaction')
    },
    async loadData({commit, dispatch}, id) {
      commit('setProperty', ['pending', true])

      await dispatch('loadSettings')

      dispatch('loadInteraction', id).finally(() => {
        commit('setProperty', ['pending', false])
      })
    },
    loadInteraction({state, commit, rootState}, id) {
      if (!id) {
        id = state.data.id
      }

      if (cancel) {
        cancel()
        cancel = null
      }

      return http.get('/api/new-interaction/get', {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
        params: {
          interaction_id: id
        }
      }).then(({data}) => {
        if (data.data === false) {
          if (rootState.user.profile.user_type === EMPLOYEE) {
            return $router.push({name: 'account-my-vacancies'})
          } else {
            return $router.push({name: 'account-received-resume'})
          }
        }

        commit('setProperty', ['data', data.data.interaction])
        commit('setProperty', ['step', data.data.interaction_step.step])
        commit('setProperty', ['waiting', !!data.data.interaction_step.loading])
        commit('setProperty', ['title', data.data.interaction_step.title])
        commit('setProperty', ['waitingText', data.data.interaction_step.message])
        commit('setProperty', ['hint', data.data.interaction_step.hint])
        commit('setProperty', ['stepData', data.data.interaction_step])
        commit('setProperty', ['statuses', data.data.statuses])
        commit('setProperty', ['vacancy', data.data.vacancy])
        commit('setProperty', ['resume', data.data.resume])
      })
    },
    loadSettings({commit}) {
      return Promise.all([
        createSettingLoad('marital_status', 'maritalStatuses', commit),
        createSettingLoad('document', 'documents', commit),
        createSettingLoad('relative_level', 'relativeLevels', commit),
        createSettingLoad('interaction_reject_reason', 'rejectReasons', commit),
        createSettingLoad('clothing_size_top', 'clothingSizes', commit),
      ])
    },
    showHintDefaultChange({commit}, value) {
      setShowHintDefaultToLocalstorage(value)
      commit('setProperty', ['showHintDefault', value])
    },
    showHintDefaultSetInitial({commit, rootState}) {
      const userType = rootState.user.profile.user_type
      let value = getShowHintDefaultFromLocalstorage()

      if (typeof value !== 'boolean') {
        value = userType !== EMPLOYER
      }

      commit('setProperty', ['showHintDefault', value])
    }
  },
}

function createSettingLoad(key, storeKey, commit) {
  return http.get(`/api/helper/selectbox/${key}`).then(({data}) => {
    commit('setProperty', [storeKey, data.data])
  })
}

function setShowHintDefaultToLocalstorage(value) {
  window.localStorage.setItem('showHintDefault', value)
}

function getShowHintDefaultFromLocalstorage() {
  const value = window.localStorage.getItem('showHintDefault')

  switch (value) {
    case 'true':
      return true
    case 'false':
      return false
  }
}
